var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { color, space, typography } from 'styled-system';
import { css, styled } from "../utils";
var StyledText = styled.p(function (_a) {
    var bold = _a.bold, align = _a.align, _b = _a.theme, colors = _b.colors, font = _b.font;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    color: ", ";\n    font-weight: ", ";\n    letter-spacing: 0.05rem;\n    line-height: 1.5;\n    margin: 0.5rem 0;\n    text-align: ", ";\n  "], ["\n    font-family: ", ";\n    color: ", ";\n    font-weight: ", ";\n    letter-spacing: 0.05rem;\n    line-height: 1.5;\n    margin: 0.5rem 0;\n    text-align: ", ";\n  "])), font.family.proximaNova, colors.lightBlack, bold ? 'bold' : 'normal', align);
}, typography, color, space);
var Text = function (props) { return React.createElement(StyledText, __assign({ "data-component": "Text" }, props)); };
Text.defaultProps = {
    align: 'left',
    bold: false,
    fontSize: [1, 1, 1, 2],
};
export default Text;
var templateObject_1;
//# sourceMappingURL=Text.js.map